import React from 'react'
import "./error.css"
// import { NavLink } from 'react-router-dom'

const Error = () => {
  return (
    <section class="page_404">
	<div class="container">
		<div class="row">	
		<div class="col-sm-12 ">
		<div class="col-sm-10 col-sm-offset-1  text-center">
		<div class="four_zero_four_bg">
			<h1 class="text-center ">404</h1>
		
		
		</div>
		
		<div class="contant_box_404">
		<h3 class="h2">
		Look like you're lost
		</h3>
		
		<p>the page you are looking for is not available!</p>

		<a href="/" class="link_404">Go to Home</a>
{/* 		<a href="" class="link_404">Go to Home</a> */}
	</div>
		</div>
		</div>
		</div>
	</div>
</section>


    // <div id="notfound">{/*404 Not Found Error*/}
    // <div className="ntfound">
    //   <div className="notfound-404">
    //     <h1>404</h1>
    //   </div>
    //   <h2>we are sorry, page not found!</h2>
    //   <p  className='mb-5'>
    //     The page you are looking for might have been removed or is temporarily unavailable.
    //   </p>
    //   <NavLink to='/'>Back To Homepage</NavLink>
    // </div>
    // </div>
  )
}

export default Error
